import type { InputAttributes, NumericFormatProps } from 'react-number-format'

export const moneyEuroFormat = {
  thousandSeparator: '.',
  decimalSeparator: ',',
  suffix: '€',
} satisfies NumericFormatProps<InputAttributes>

export const standardDecimalFormat = {
  thousandSeparator: '.',
  decimalSeparator: ',',
} satisfies NumericFormatProps<InputAttributes>

export const positivDecimalFormat = {
  thousandSeparator: '.',
  decimalSeparator: ',',
  allowNegative: false,
} satisfies NumericFormatProps<InputAttributes>
